import React, { useEffect } from "react";
import { Route, Routes } from "react-router-dom";

import Users from "./users";
import SingleUser from "./single-user";

import { setModule } from "@store/user-store";

import { Modules } from "@interfaces/common";

const UsersRoutes = () => {
  useEffect(() => {
    setModule(Modules.USERS);
  }, []);

  return (
    <Routes>
      <Route path="/*" Component={Users} />
      <Route path="/users/:id" Component={SingleUser} />
    </Routes>
  );
};

export default UsersRoutes;
